import Api from 'api';
import uuid from 'uuid';
import {
  IMPORT_SET_FILE,
  IMPORT_REMOVE_FILE,
  IMPORT_UPLOAD_FILE,
  IMPORT_PROGRESS_FILE,
  IMPORT_FILE,
  SET_IMPORT_PAGINATION,
  SET_IMPORT_FILTERS,
  GET_IMPORT_RECORDS,
  MODIFY_EDITING_IMPORT,
  RESET_IMPORT,
} from 'import/constants';

export const setFile = (file) => ({
  type: IMPORT_SET_FILE,
  payload: {
    id: uuid.v4(),
    file: file,
    status: 'files.pending',
    percentage: 0,
    preview: file.preview,
    name: file.name,
  },
});

export const modify = (payload) => ({ type: MODIFY_EDITING_IMPORT, payload });

export const removeFile = (id) => ({
  type: IMPORT_REMOVE_FILE,
  payload: id,
});

export const uploadFile = (file, companyId, subcompanyId) => (dispatch) =>
  dispatch({
    type: IMPORT_UPLOAD_FILE,
    payload: Api.uploads.upload(
      file.file,
      (percentage) => dispatch(progressFile(percentage)),
      companyId,
      subcompanyId
    ),
  });

export const progressFile = (percentage) => ({
  type: IMPORT_PROGRESS_FILE,
  payload: percentage,
});

export const importFile = (companyId, subcompanyId, data) => ({
  type: IMPORT_FILE,
  payload: Api.imports.import(companyId, subcompanyId, data),
});

export const setPagination = (payload) => ({
  type: SET_IMPORT_PAGINATION,
  payload,
});

export const setFilters = (payload) => ({
  type: SET_IMPORT_FILTERS,
  payload,
});

export const fetch = (companyId, subcompanyId, filters, limit, page, orderBy, order) => ({
  type: GET_IMPORT_RECORDS,
  meta: { needAuth: true },
  payload: Api.imports.fetch(companyId, subcompanyId, filters, limit, page, orderBy, order),
});

export const reset = () => ({ type: RESET_IMPORT });



// WEBPACK FOOTER //
// src/modules/secured/modules/import/actions/import_actions.js